angular.module('dnecom')
    .controller('TaxModalController', ["$scope", "$uibModalInstance", "taxClass", function($scope, $uibModalInstance, taxClass) {
        $scope.taxClass = angular.copy(taxClass.taxClass || taxClass);
        $scope.inputInvalid = false;

        $scope.save = function(redirect) {
            if (!$scope.taxClass.name) {
                $scope.inputInvalid = true;
                return;
            }

            $uibModalInstance.close({
                taxClass: $scope.taxClass,
                redirect: redirect
            });
        };

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }]);
